
import { Component, Prop, Vue } from 'vue-property-decorator'
import { GradeCode } from '@/const/GradeCode'

/**
 * 学年表示チップ
 */
@Component
export default class GradeTip extends Vue {
  /** 学年コード */
  @Prop()
  private gradeCode!: string

  /**
   * 学年コードからラベルを引当てて返す
   *
   * @returns 学年のラベル
   */
  private get label(): string {
    const label = GradeCode.findByCode(this.gradeCode)?.label
    return label || ''
  }

  /**
   * css定義用メソッド
   *
   * @returns css指定
   */
  private setStyle(): { [key: string]: string } {
    const color = GradeCode.findByCode(this.gradeCode)?.color
    return {
      '--color-grade': `var(${color})`,
    }
  }
}
